const TOKENS_SORT_TYPES = {
    ASCENDING: 0,
    DESCENDING: 1,
  };
  
const TOKENS_SORT_KEYS = {
  TOKEN_NAME: 0,
  TOKEN_SYMBOL: 1,
  DECIMALS: 2,
  TOKEN_ADDRESS: 3,
  TOKEN_OWNER_ADDRESS: 4,
  TOTAL_SUPPLY: 5,
  TOKEN_PRICE_IN_MERX: 6,
  TOKEN_PRICE_IN_USD: 7,
  DISTRIBUTION: 8,
  CURRENT_PRICE: 9,
};
  
  const sortTypes = [
    {
      name: 'Ascending',
      icon: 'BiSortUp',
    },
    {
      name: 'Descending',
      icon: 'BiSortDown',
    },
  ];
  
const sortKeys = [
  {
    name: 'Token Name',
    key: 'name',
    type: 'string',
    defaultSortType: TOKENS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Token Symbol',
    key: 'symbol',
    type: 'string',
    defaultSortType: TOKENS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Decimal',
    key: 'decimals',
    type: 'number',
    defaultSortType: TOKENS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Token Address',
    key: 'address',
    type: 'string',
    defaultSortType: TOKENS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Token Owner Address',
    key: 'owner_address',
    type: 'string',
    defaultSortType: TOKENS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Total Supply',
    key: 'total_supply',
    type: 'number',
    defaultSortType: TOKENS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Token Price in MERX',
    key: 'price_in_mercurx',
    type: 'number',
    defaultSortType: TOKENS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Token Price in USD',
    key: 'price_in_usd',
    type: 'number',
    defaultSortType: TOKENS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Distribution',
    key: 'distribution',
    type: 'number',
    defaultSortType: TOKENS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Current Price',
    key: 'current_price',
    type: 'number',
    defaultSortType: TOKENS_SORT_TYPES.DESCENDING,
  },
];
  
  const tokensQuickFilterConstants = {
    ALL: 1,
    ACTIVE: 2,
    COMPLETED: 3,
  };
  
  export {
    TOKENS_SORT_KEYS,
    TOKENS_SORT_TYPES,
    sortTypes,
    sortKeys,
    tokensQuickFilterConstants,
  };
  
